module.exports = __webpack_public_path__ + "static/img/tiandi.9c0a901a.png";